import React, { useEffect, useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import Header from "./header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../Fotter";
import {
  FaShoppingCart,
  FaCreditCard,
  FaArrowCircleRight,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import { toast } from "react-toastify";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { FaStar, FaRegStar } from "react-icons/fa";
import { GetReview } from "../redux/slices/GetReviewSlice";
import { ProductById } from "../redux/slices/ProductByIdSlice";
import { AddReview } from "../redux/slices/AddReviewSlice";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { CustomeStyle } from "../Css/CustomeStyle";
import AllProduct from "./AllProduct";
import { FiArrowRight } from "react-icons/fi";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";

const ProductDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const item =
    location.state?.item || location?.state?.productId || location?.state?.name;
  const { ViewCart } = useSelector((state) => state.viewCart);
  const [isInCart, setIsInCart] = useState(false);
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isExpanded, setIsExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [review, setReview] = useState("");
  const [userName, setUserName] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const { id } = useParams();
  const [showTooltip, setShowTooltip] = useState(false);
  const page = location?.state?.page;
  const [dataDetails, setDataDetails] = useState([]);
  const [dataCat, setDataCat] = useState("");
  const [dataVarId, setVarId] = useState("");
  const [selectedSize, setSelectedSize] = useState(null);
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0); // ye top pe le aata hai
  }, []);

  const handleClose = () => {
    setShowTooltip(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTooltip(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (dataDetails?.product?.images?.length > 0) {
      setSelectedImage(dataDetails?.product?.images[0]);
    }
  }, [dataDetails]);

  const toggleDescription = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    dispatch(viewCartData());
  }, [dispatch, id]);

  useEffect(() => {
    const fetchDataDetails = async () => {
      setLoader(true)
      try {
        const sessionId = localStorage.getItem("uuid");
        const headers = {
          Authorization: sessionId || "",
        };

        const response = await axios.get(
          `${endPoint.ProductSerchById}/${id ? id : item?._id}`,
          { headers }
        );
        setLoader(false)
        setDataCat(response?.data?.product);
        setDataDetails(response?.data);
      } catch (error) {
        setLoader(false)
        console.error("Error fetching data:", error.message);
      }
    };

    fetchDataDetails();
  }, []);

  useEffect(() => {
    showAddCart();
  }, [ViewCart, isInCart]);

  const showAddCart = () => {
    if (Array.isArray(ViewCart?.cart)) {
      const cartExists = ViewCart?.cart.some(
        (cartItem) => cartItem?.productId === item?._id
      );
      if (isInCart !== cartExists) {
        setIsInCart(cartExists);
      }
    } else {
    }
  };

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  // const handleAddToCart = () => {
  //   const cartData = {
  //     productId: item?._id,
  //     quantity: 1,
  //     variationsId: dataVarId,
  //     size: selectedSize ? selectedSize : "",
  //   };
  //   dispatch(AddToCart(cartData)).then((result) => {
  //     if (result.meta.requestStatus === "fulfilled") {
  //       dispatch(viewCartData());
  //       toast.success("Product added to cart!", {
  //         position: "top-right",
  //         autoClose: 2000,
  //         style: {
  //           backgroundColor: "#d0d3d4 ",
  //           color: "black",
  //           fontWeight: "bold",
  //         },
  //       });
  //     } else {
  //       console.log("Responce Error");
  //     }
  //   });
  // };

  const handleAddToCart = () => {
    const sizeRequired = dataDetails?.product?.size?.length > 0;

    if (sizeRequired && !selectedSize) {
      toast.error("Please select a size", {
        position: "top-right",
        autoClose: 2000,
        style: {
          backgroundColor: "#f8d7da",
          color: "#721c24",
          fontWeight: "bold",
        },
      });
      return;
    }

    const cartData = {
      productId: item?._id ? item?._id : id,
      quantity: 1,
      variationsId: dataVarId,
      size: selectedSize || "",
    };

    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        console.log("Response Error");
      }
    });
  };

  const handleAddToCartBuy = () => {
    const cartData = {
      productId: item?._id ? item?._id : id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        navigate("/cart");
      } else {
        console.log("Responce Error");
      }
    });
  };

  const handleSubmit = () => {
    const reviewData = {
      productId: item?._id,
      rating: rating,
      comment: review,
      name: userName,
    };
    dispatch(AddReview(reviewData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(GetReview(item?._id));
        setShowModal(false);
        setRating(0);
        setReview("");
        setUserName("");
      } else {
        console.log("Hello world");
      }
    });
  };

  const handleBack = () => {
    if (page) {
      navigate("/AllProductData", {
        state: {
          page,
        },
      });
    } else {
      // navigate(-1);
      navigate(-1, { replace: true });
    }
  };

  const _handleClick = () => {
    const url = `/ShowCategoryData/${dataCat.category}/${id}`;
    navigate(url);
  };

  const _handlebrand = () => {
    const url = `/brand/${dataCat.brand}/${id}`;
    navigate(url);
  };

  const description = dataDetails?.product?.description || "";
  const descriptionPoints = description?.split(/(?<=[.:])\s+(?=[A-Z])/);

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const ChangeData = async (_id) => {
    setVarId(_id);
    try {
      const sessionId = localStorage.getItem("uuid");
      const headers = {
        Authorization: sessionId || "",
      };

      const response = await axios.get(
        `${endPoint.ProductSerchById}/${id ? id : item?._id
        }?variationId=${_id}`,
        { headers }
      );
      setDataDetails(response?.data);
      dispatch(viewCartData());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  return (
    <div className="min-h-screen text-black">
      <Header />
      {showTooltip && (
        <div className="fixed bottom-8 right-8 bg-gradient-to-r from-[#e2ebf0] to-[#fdfbfb] border border-gray-200 text-gray-800 p-4 rounded-xl shadow-xl w-80">
          <div className="flex justify-between items-start mb-3">
            <div className="pr-2">
              <p className="text-base font-semibold">Get the App</p>
              <p className="text-sm text-gray-600">
                Enjoy faster, smoother access by downloading our mobile app.
              </p>
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 text-xl font-bold leading-none"
            >
              ❌
            </button>
          </div>
          <div className="flex justify-center">
            <a
              href="https://play.google.com/store/apps/details?id=com.bharatcod&hl=en" // Replace with your actual link
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-blue-500 hover:bg-blue-600 text-white text-sm px-5 py-2 rounded-md font-medium transition">
                Download App
              </button>
            </a>
          </div>
        </div>
      )}

      <div className="flex mx-auto justify-center items-center  w-[90%]  mt-5 justify-between hidden sm:flex">
        <button
          onClick={handleBack}
          className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center "
        >
          <AiOutlineArrowLeft className="text-lg mr-1" />
        </button>
        <h1 className="text-4xl font-bold text-center text-gray-600 hidden md:block">
          Product Details
        </h1>
        <h1></h1>
      </div>

      {loader ? (
        <div className="flex justify-center items-center m-5">
          <div className="text-lg font-semibold animate-pulse">Loading...</div>
        </div>
      ) : (
        <>
          <div className="flex flex-col md:flex-row  mt-4 md:mt-8 sm:mt-10 w-[90%] mx-auto justify-center">
            <div className="w-full md:w-1/2 flex justify-center mb-10">
              <div className="sticky top-24 max-h-[calc(100vh-100px)]">
                <div className="relative flex justify-center w-[90%]">
                  <Zoom>
                    <img
                      src={selectedImage}
                      alt="Product"
                      className="h-96 border p-4 border-gray-300 sm:mt-0 mt-4 sm:w-full sm:ml-0 ml-5"
                    />
                  </Zoom>
                  <button
                    className="like-btn absolute sm:top-2 top-6 right-6 sm:right-3"
                    onClick={() => toggleLike(dataDetails?.product?._id)}
                  >
                    {likedProducts.has(dataDetails?.product?._id) ? (
                      <FaHeart size="24px" color="red" />
                    ) : (
                      <FaRegHeart size="24px" color="pink" />
                    )}
                  </button>
                </div>

                {dataDetails?.product?.images && (
                  <div className="flex justify-center gap-4 mt-4 bg-white p-2">
                    {dataDetails.product?.images.slice(0, 3).map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt={`Product image ${index + 1}`}
                        className={`w-[100px] h-[100px] object-cover rounded-md border-2 cursor-pointer hover:scale-110 transition-transform ${selectedImage === image
                          ? "border-blue-500"
                          : "border-gray-300"
                          }`}
                        onClick={() => setSelectedImage(image)}
                      />
                    ))}
                  </div>
                )}

                <div
                  className="bottom-0 sm:bottom-4 flex gap-2 justify-center fixed
            left-0 right-0 bg-blue-50  sm:relative sm:mb-0 sm:bg-transparent sm:shadow-none
            sm:flex-row sm:justify-center sm:gap-5 sm:p-0 sm:mt-10 sm:z-0 z-10"
                >
                  <button
                    onClick={() => handleAddToCart()}
                    className="bg-white border text-black text-lg font-semibold px-3 py-2 rounded-xl shadow-md hover:text-white hover:bg-blue-600 transition duration-300 flex items-center gap-3"
                  >
                    <FaShoppingCart size={20} />
                    <span>Add to Cart</span>
                  </button>
                  <button
                    onClick={() => {
                      handleAddToCartBuy();
                      navigate("/cart");
                    }}
                    className="bg-orange-400 text-white text-lg font-semibold py-3 px-6 rounded-xl shadow-md hover:bg-green-600 transition duration-300 flex items-center gap-3"
                  >
                    <FaCreditCard size={20} />
                    <span>Buy Now</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/2 flex flex-col md:px-8 ">
              <span className="text-xl sm:mt-0 mt-3 sm:text-2xl md:text-2xl font-bold">
                {dataDetails?.product?.title}
              </span>
              <div className="flex items-center mt-3">
                <span className="text-red-600 text-3xl font-bold">
                  ₹{dataDetails?.product?.price}
                </span>
                <span className="line-through text-gray-500 text-lg ml-2">
                  ₹{dataDetails?.product?.regularPrice}
                </span>
              </div>
              <div className="text-xl mt-2 flex items-center gap-2">
                <span className="font-bold">Category:</span>
                <div
                  onClick={() => _handleClick()}
                  className="text-orange-600 hover:text-orange-800 hover:underline flex items-center gap-1"
                >
                  {dataDetails?.product?.category}
                  <FaArrowCircleRight className="text-orange-400" />
                </div>
              </div>
              <div className="text-xl mt-2 flex items-center gap-2">
                <span className="font-bold">Brand: </span>
                <div
                  onClick={() => _handlebrand()}
                  className="text-orange-600 hover:text-orange-800 hover:underline flex items-center gap-1"
                >
                  {dataDetails?.product?.brand}
                  <FaArrowCircleRight className="text-orange-400" />
                </div>
                {/* <span className="text-gray-700">{dataDetails?.brand}</span> */}
              </div>

              {dataDetails?.product?.size?.length > 0 && (
                <div className="mt-3">
                  <h3 className="font-bold text-lg sm:text-1xl mb-2">
                    Select Size:
                  </h3>
                  <div className="flex flex-wrap gap-3">
                    {dataDetails?.product?.size.map((size) => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`px-4 py-2 rounded-lg border-2 text-lg font-semibold transition-all duration-300
            ${selectedSize === size
                            ? "bg-blue-600 text-white border-blue-600 shadow-md"
                            : "bg-white text-gray-700 border-gray-300 hover:border-blue-500 hover:text-blue-600"
                          }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {dataDetails?.product?.specifications && (
                <div className="mt-3">
                  <h3 className="font-semibold text-2xl mb-2">Specifications:</h3>
                  <table className="w-full border rounded-md">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="px-4 py-2 text-left">Specification</th>
                        <th className="px-4 py-2 text-left">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataDetails?.product?.specifications.map((spec) => (
                        <tr key={spec.key} className="border-t">
                          <td className="px-4 py-2">{spec.key}</td>
                          <td className="px-4 py-2">{spec.values}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <h2 className="font-bold text-lg sm:text-2xl mt-3">Description</h2>

              <ul className="list-disc pl-4 space-y-1">
                {(isExpanded
                  ? descriptionPoints
                  : descriptionPoints?.slice(0, 5)
                )?.map((point, index) => (
                  <li key={index}>{point.trim()}</li>
                ))}
              </ul>

              {descriptionPoints?.length > 5 && (
                <div className="text-end me-5">
                  <button
                    className="text-blue-500 mt-1"
                    onClick={toggleDescription}
                  >
                    {isExpanded ? "Less" : "More"}
                  </button>
                </div>
              )}

              {dataDetails?.stock != 0 && (
                <div className="mt-3  pb-2">
                  <h3 className="font-bold text-lg sm:text-2xl mb-2">
                    Stock Availability:
                  </h3>
                  <p className="text-lg">{dataDetails?.product?.stock} in stock</p>
                </div>
              )}
            </div>
          </div>

          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-10 rounded-lg shadow-lg w-[80%]">
                <h2 className="text-lg font-semibold mb-3">Rate Your Experience</h2>

                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, index) => {
                    const starValue = index + 1;
                    return (
                      <FaStar
                        key={index}
                        size={24}
                        className={`cursor-pointer ${starValue <= (hover || rating)
                          ? "text-yellow-400"
                          : "text-gray-300"
                          }`}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(starValue)}
                      />
                    );
                  })}
                </div>
                <input
                  type="text"
                  placeholder="Enter your name"
                  className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />

                <textarea
                  rows="3"
                  placeholder="Write your review..."
                  className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={review}
                  onChange={(e) => setReview(e.target.value)}
                ></textarea>

                <div className="flex justify-end gap-2 mt-4">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-3 py-1 border rounded-md hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit}
                    className="bg-blue-600 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-700 transition"
                    disabled={!userName || !rating || !review}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}

          {dataDetails?.variations?.length !== 0 && (
            <div className="w-[90%]  mx-auto bg-white border border-gray-300 p-3 mt-10 mb-10">
              <div className={`${CustomeStyle.row} flex items-center gap-4`}>
                <div className="flex justify-between items-center w-full">
                  <h3 className={CustomeStyle.headerText}>More Like This</h3>
                  {dataDetails?.variations?.length >= 8 && (
                    <Link
                      to="/AllProductData"
                      className="text-red-500 hover:text-red-700 flex items-center space-x-2  no-underline"
                    >
                      <span className="text-black font-bold">View All</span>
                    </Link>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap justify-start gap-4 mt-3">
                {dataDetails?.variations?.map((item, index) => (
                  <div
                    key={item._id}
                    className="bg-gray-100 rounded-lg py-2 px-1 w-[145px] sm:w-[180px] 
               md:w-[150px] flex-none text-center flex flex-col items-center justify-center 
               cursor-pointer relative"
                  >
                    <button
                      className="like-btn absolute top-2 right-2"
                      onClick={() => toggleLike(item._id)}
                    >
                      {likedProducts.has(item._id) ? (
                        <FaHeart size="24px" color="red" />
                      ) : (
                        <FaRegHeart size="24px" color="gray" />
                      )}
                    </button>

                    <img
                      src={item?.images?.[0]}
                      alt={item.variationTitle}
                      className="w-30 h-[60px] sm:h-[80px] md:h-[120px] object-cover mb-2"
                    />

                    <Link
                      to={`/category/${dataCat?.category ? generateSlug(dataCat?.category) : "-"
                        }/${generateSlug(item?.variationTitle)}/${generateSlug(id)}`}
                      state={{ item }}
                      className="block w-full hover:scale-105 hover:-translate-y-1  no-underline"
                      onClick={() => {
                        ChangeData(item?.id);
                      }}
                    >
                      {item?.variationTitle && (
                        <div className={CustomeStyle.OnetextBlack}>
                          <span className="text-black text-lg font-bold line-clamp-1">
                            {item.variationTitle}
                          </span>
                        </div>
                      )}
                      {item?.color && (
                        <div className="flex items-center justify-center">
                          <span className="text-black text-sm font-semibold line-clamp-1">
                            Color:- {item?.color}
                          </span>
                        </div>
                      )}
                      <div className="flex items-center justify-center">
                        <span className="text-black text-sm font-semibold line-clamp-1">
                          Price :- ₹{item?.price}
                        </span>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
      <div className="sm:mt-20 mt-3">
        <Footer />
      </div>
    </div>
  );
};

export default ProductDetails;
